import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  campaigns: [],
  loading: false,
  error: null,
};

const marketingSlice = createSlice({
  name: 'marketing',
  initialState,
  reducers: {
    setCampaigns: (state, action) => {
      state.campaigns = action.payload;
    },
    addCampaign: (state, action) => {
      state.campaigns.push(action.payload);
    },
    updateCampaign: (state, action) => {
      const index = state.campaigns.findIndex(campaign => campaign.id === action.payload.id);
      if (index !== -1) {
        state.campaigns[index] = action.payload;
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setCampaigns, addCampaign, updateCampaign, setLoading, setError } = marketingSlice.actions;
export default marketingSlice.reducer;